import React, { ReactElement } from 'react';
import { Modal, MODAL_ANIMATION_TYPE, MODAL_CLOSE_BUTTON, MODAL_TYPE } from 'b2b-components/theme/components/Modal';
import { useTranslate } from 'b2b-apps/shop/i18n/hooks';
import { Form } from '../Form';
import './AddToWishlistModal.scss';

interface AddToWishListModalProps {
  isModalOpened: boolean;
  onModalClose: () => void;
  skus: string[];
}

export const AddToWishListModal = ({
  isModalOpened,
  onModalClose,
  skus,
}: AddToWishListModalProps): ReactElement => {
  const t = useTranslate();

  return (
    <Modal
      animationType={MODAL_ANIMATION_TYPE.fade}
      className='AddToWishlist-Modal'
      closeButton={MODAL_CLOSE_BUTTON.right}
      content={() => <Form skus={skus} onModalClose={onModalClose} />}
      isOpen={isModalOpened}
      onCloseModal={onModalClose}
      text={{
        ariaLabel: skus.length > 1
          ? t('Add {count} items to wishlist', { count: skus.length })
          : t('Add item to wishlist'),
        ariaCloseModal: t('Cancel'),
      }}
      type={MODAL_TYPE.small}
    />
  );
};
